<app-orders-table
  [dataSource]="dataSource"
  [orderState]="OrderStateEnum.Alert"
  [warehouses]="warehouses"
  [businesses]="businesses"
  [displayedColumns]="displayedColumns"
  [allowRestartLottery]="true"
  (tableActionTaken)="handleTableAction($event)"
></app-orders-table>
